<!-- Invoice -->
<div *ngIf="showHeader" class="flex align-items-center justify-content-between cursor-pointer" pStyleClass="@next"
  enterFromClass="hidden" enterActiveClass="scalein" leaveToClass="hidden" leaveActiveClass="fadeout"
  [hideOnOutsideClick]="true">
  <div class="flex align-items-center justify-content-center">
    <div class="h-2rem w-2rem bg-primary text-white border-round flex align-items-center justify-content-center">
      <i class="fa fa-file-invoice"></i>
    </div>
    <div class="ml-3">
      <h4 class="text-base mb-0 line-height-1 font-bold">{{'TRANSACTION.INVOICES' | translate}}</h4>
      <p class="mb-0 text-xs text-600" *ngIf="!loading && invoiceData$ | async">
        {{ totalItems$.value }} {{'TRANSACTION.INVOICES_GENE' | translate}}
      </p>
      <p-skeleton *ngIf="loading" width="7rem" height="0.9rem" styleClass="mt-1"></p-skeleton>
    </div>
  </div>
  <i class="fa fa-circle-chevron-down text-primary"></i>
</div>

<div [ngClass]="showHeader ? 'hidden mt-2':''">
  <!-- Content -->
  <app-data-grid [columnData]="invoiceData$" [columns]="invoiceTablecolumns$" [selectable]="selecallInvoiceData" [totalRecords]="totalRecordLength"
    (emitValue)="handleEvent($event)" (emitSelectValue)="handleSelectAll($event)" tableClasses="shadow-2 p-0 my-3"
    [headerClasses]="'surface-100 text-xs text-600 white-space-nowrap'" (loadNextData)="fetchNextSetData($event)" (onAction)="onActionEvent($event)"
    [EmptyState]="emptyStateComponent$" [paginator]="true" [loading]="loading"
    [gridName]="'invoice-list'">
  </app-data-grid>
  <!-- Content -->
</div>

<!-- Invoice -->



<!-- Void Invoice Modal -->
<p-dialog [(visible)]="showVoidInvoiceModal" [resizable]="false" appendTo="body" [modal]="true"
  [breakpoints]="{'767px': '100vw'}" [style]="{width: '630px'}" styleClass="no-header-modal">

  <ng-template pTemplate="header" styleClass="hidden"></ng-template>
  <ng-template pTemplate="content" styleClass="p-0">

    <!-- Content -->
    <form [formGroup]="voidInvoiceForm">
      <div class="relative text-center p-4">

        <div class="fa fa-times opacity-50 absolute right-0 top-0 mt-3 mr-3 md:mt-4 md:mr-4 cursor-pointer"
          (click)="showVoidInvoiceModal = false"></div>

        <img width="160" class="block mx-auto" src="/assets/img/void-invoice-img.svg" alt="Image" />

        <h4 class="text-base md:text-lg my-3 font-bold">{{'INVOICE.INVOICE_DEL_CONFI'| translate}} <br>
          {{invoiceDetails.number_prefix}} ?</h4>
        <p class="text-600 md:w-26rem mx-auto mb-0">{{'INVOICE.INVOICE_DEL_INFO'| translate}}</p>

      </div>
      <!-- Content -->

      <!-- Content -->
      <div class="surface-100 p-4">
        <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'INVOICE.REASON'| translate}}</label>
        <textarea pInputTextarea formControlName="void_reason" class="text-sm w-full h-5rem"></textarea>
        <app-error-msg *ngIf="VoidReasonFormControl.touched && VoidReasonFormControl.invalid"
          [errors]="VoidReasonFormControl.errors" [fieldLabel]="'INVOICE.REASON_REQUIRED' | translate">
        </app-error-msg>
      </div>
      <!-- Content -->

      <!-- Modal Footer -->
      <div class="flex align-items-center justify-content-between px-4 py-3 border-top-1 border-300">
        <button pButton pRipple type="button" [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate"
          class="p-button-primary p-button-text text-sm" (click)="showVoidInvoiceModal = false">
        </button>
        <button pButton pRipple type="button" [label]="'INVOICE.VOID_LABEL' | translate" class="p-button-danger text-sm" [loading]="btnLoading"
          (click)="deleteInvoice(voidInvoiceForm)">
        </button>
      </div>
      <!-- Modal Footer -->
    </form>

  </ng-template>

</p-dialog>
<!-- Void Invoice Modal -->

<!-- Send Link - Collect Dues  -->
<p-dialog [(visible)]="sendLinkCollectDues" [resizable]="false" appendTo="body" [modal]="true"
  [breakpoints]="{'991px': '100vw'}" [style]="{width: '500px'}" styleClass="no-header-modal">

  <ng-template pTemplate="header" styleClass="hidden"></ng-template>
  <ng-template pTemplate="content" styleClass="p-0">

    <!-- Content -->
      <!-- Modal Header -->
      <div class="p-3 flex align-items-center justify-content-between border-bottom-1 border-300">
        <h2 class="mb-0 text-sm">{{'SUBSCRIPTIONS.COLLECTDUES_SENDLINKCOLLECTDUESHEADERINV' | translate }}</h2>
        <i class="fa fa-times text-xl text-600 cursor-pointer" (click)="sendLinkCollectDues = false"></i>
      </div>
      <!-- Modal Header -->


      <div class="py-4 px-3">

        <p class="text-sm mb-5">{{'SUBSCRIPTIONS.COLLECTDUES_SENDLINKCOLLECTINVOICEDUE' | translate }}</p>

        <h4 class="text-sm text-600 mb-2 font-normal">{{'SUBSCRIPTIONS.COLLECTDUES_SENDON' | translate }}</h4>

        <div class="p-buttonset white-space-nowrap">
          <button [ngClass]="emailSelected ? 'p-button-primary' : 'p-button-secondary' "
            (click)="emailSelected=!emailSelected" class="p-button-primary border-right-1 text-sm border-white" pButton
            pRipple label="{{'SUBSCRIPTIONS.COLLECTDUES_EMAIL' | translate }}" icon="fa fa-envelope font-light"></button>
          <button [ngClass]="smsSelected ? 'p-button-primary' : 'p-button-secondary' "
            (click)="smsSelected=!smsSelected" class="p-button-primary border-right-1 text-sm border-white" pButton
            pRipple label="{{'SUBSCRIPTIONS.COLLECTDUES_SMS' | translate }}"
            icon="fa fa-comments font-light"></button>
          <button [ngClass]="whatsappSelected ? 'p-button-primary' : 'p-button-secondary' "
            (click)="whatsappSelected=!whatsappSelected" class="p-button-primary border-right-1 text-sm border-white"
            pButton pRipple label="{{'SUBSCRIPTIONS.COLLECTDUES_WHATSAPP' | translate }}"
            icon="fab fa-whatsapp"></button>
        </div>

      </div>


      <!-- Content -->


      <!-- Modal Footer -->
      <div class="p-3 border-top-1 border-300 flex align-items-center justify-content-between">
        <p-button pRipple type="button" [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate"
          class="p-button-primary p-button-text text-sm" (click)="sendLinkCollectDues = false">
        </p-button>

        <p-button pRipple type="button" [label]="'SUBSCRIPTIONS.BTN_SEND' | translate"
          (click)="SendCollectDuesLink(sendLinkCollectDuesForm)" styleClass="text-sm">
        </p-button>

      </div>
      <!-- Modal Footer -->
    
  </ng-template>
</p-dialog>
<!-- Send Link - Collect Dues -->

<payment *ngIf="showPayment" [showPayment]="showPayment" [invoiceDetailById]="invoiceClientdataObject"
  (GoToClientSubscription)="GoToClientDetails($event)" (hidePaymentSidebar)="HidePaymemt($event)" closeOnEscape="false">
</payment>

<change-bill-owner *ngIf="(showChangeBillOwner | async) as showPopup" [visible]="showPopup"
  [invoiceData]="invoiceDetails" (closeDialog)="closeDialogEvent($event)">
</change-bill-owner>

<create-sales-return *ngIf="(createSalesReturn | async) as showPopup" [visible]="showPopup"
  [invoiceData]="invoiceById" (closeDialog)="closeSalesReturnDialogEvent($event)" [invoiceId]="invoiceId">
</create-sales-return>

<write-off *ngIf="showWriteOff.value || showWriteOffList.value" [visible]="showWriteOff.value" [showList]="showWriteOffList.value"
  [invoiceData]="invoiceDetails" (closeDialog)="closeWriteOffDialogEvent($event)" [clientId]="clientId" [tenantId]="tenantId">
</write-off>
